import React, { useState } from 'react'
import './Input.css'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import CreateTwoToneIcon from '@material-ui/icons/CreateTwoTone';
import GeneratedQR from './GeneratedQR'
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 50,
    },
  }));

function Input() {

    const classes = useStyles();

    const [value, setValue] = useState('')
    const [searchValue, setSearchValue] = useState()
    const [format, setFormat] = useState('png')
    const [size, setSize] = useState(100)

    const generateQR = () => {
        var URL = 'https://api.qrserver.com/v1/create-qr-code/?data=' + value + '&size='+ size +'x' + size 
        document.getElementById('output').src=URL
        setSearchValue('https://api.qrserver.com/v1/create-qr-code/?data=' + value + '&size='+ size +'x' + size )        
    }


    return (
        <div className="input">
            <form className="input__form" onSubmit={(e) => {e.preventDefault(); generateQR()}}>
                <TextField 
                    id="inputValue" 
                    label="Enter Data/URL" 
                    variant="outlined"                    
                    onChange={(e) => setValue(e.target.value)}
                />
                <FormControl className ="input__format" className={classes.formControl}>
                    <InputLabel>File Format</InputLabel>
                    <Select
                        id="fileFormat"
                        onChange={(e) => setFormat(e.target.value)}
                    >
                        <MenuItem value={'png'}>PNG</MenuItem>
                        <MenuItem value={'jpg'}>JPG</MenuItem>
                        <MenuItem value={'jpeg'}>JPEG</MenuItem>
                        <MenuItem value={'svg'}>SVG</MenuItem>                        
                        <MenuItem value={'gif'}>GIF</MenuItem>
                    </Select>
                </FormControl>
                <FormControl className ="input__size" className={classes.formControl}>
                    <InputLabel>Size (in px)</InputLabel>
                    <Select
                        id="imgSize"
                        onChange={(e) => setSize(e.target.value)}
                    >
                        <MenuItem value={100}>100</MenuItem>
                        <MenuItem value={200}>200</MenuItem>
                        <MenuItem value={250}>250</MenuItem>
                        <MenuItem value={300}>300</MenuItem>
                    </Select>
                </FormControl>
                <Button
                    variant="contained"
                    color="primary"
                    endIcon={<CreateTwoToneIcon/>}
                    onClick={() => generateQR()}
                >
                Generate
                </Button>
                <img alt="" id="output" className="input__image"/>
                {searchValue ?
                <GeneratedQR value={value} searchValue={searchValue} format={format} />
                : null
                }
            </form>
            <button type="submit" style={{display: "none"}}></button>
        </div>
    )
}

export default Input
